import React from 'react'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import { CSSTransition } from 'react-transition-group'

import VirtualKeyboard from 'components/virtual_keyboard/virtual_keyboard'
import mathSymbolsProvider from 'helpers/mathSymbolsProvider'
import CSSModules from 'react-css-modules'

import styles from './VirtualKeyboardFull.scss'

import MathSymbolsSvg from 'assets/components/activity_textarea/math-icon.svg'

class VirtualKeyboardFull extends React.PureComponent {

	constructor() {
		super()

		this.state = {
			isOpen: false,
		}
	}

	toggle = () => {
		this.props.onToggle(this.state.isOpen)
		this.setState({
			isOpen: !this.state.isOpen,
		})
	}

	render() {
		return (
			<CSSTransition
				in
				appear
				classNames={{
					appear: styles.appear,
					appearActive: styles['appear-active'],
				}}
				timeout={300}
			>
				<div styleName='math-symbols'>
					<button styleName='math-symbols-button' onClick={this.toggle}>
						<Isvg src={MathSymbolsSvg}
							cacheGetRequests={true}
						/>
					</button>
					{ this.state.isOpen &&
					<div styleName='math-symbols-keyboard'>
						<VirtualKeyboard
							mode={this.props.mode}
							provider={mathSymbolsProvider}
							mathSymbolChange={
								this.props.onChange
							}
							onContainerClick={
								this.props.onContainerClick
							}
						/>
					</div>
					}
				</div>
			</CSSTransition>
		)
	}
}

VirtualKeyboardFull.propTypes = {
	onChange: PropTypes.func,
	onContainerClick: PropTypes.func,
	mode: PropTypes.string,
	onToggle: PropTypes.func,
}

VirtualKeyboardFull.defaultProps = {
	mode: 'normal',
	onChange: () => {},
	onContainerClick: () => {},
	onToggle: () => {},
}

export default CSSModules(VirtualKeyboardFull, styles, { allowMultiple: true })
